import { Alert, Done, Error, Info, Warning } from '../../icons';
import { Severity } from '../../types';
import { Loading } from '../Loading';

interface ToastIconProps {
  severity: Severity;
}

export const NotificationToastIcon = ({ severity }: ToastIconProps) => {
  const iconMap: Record<Severity, JSX.Element> = {
    success: <Done className="size-4 text-[#2FCFD3]" />,
    error: <Error className="size-4 text-[#E02D75]" />,
    warning: <Warning className="size-4 text-[#F0C723]" />,
    info: <Info className="text-primary size-4" />,
    alert: <Alert className="text-primary size-4" />,
    loading: <Loading className="text-primary size-4" />,
  };

  return iconMap[severity] || null;
};
